import { render, staticRenderFns } from "./StringWithMarkup.vue?vue&type=template&id=3d1f423f"
import script from "./StringWithMarkup.vue?vue&type=script&lang=js"
export * from "./StringWithMarkup.vue?vue&type=script&lang=js"
import style0 from "./StringWithMarkup.vue?vue&type=style&index=0&id=3d1f423f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports